export default class InstalationUserRelationshipModel {
    IdNRelacionInstalacionUsuario: number | null;
    fkNInstalacion: number | null;
    fkNUsuario: number | null;   

    constructor() {
        this.IdNRelacionInstalacionUsuario = null;
        this.fkNInstalacion = null;
        this.fkNUsuario = null;
    }


}

